import { useEffect } from "react";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";

const Pagination = ({ current_page, total, per_page, setParams }) => {
  let pages: any = [];
  let totalPages = Math.ceil(total / per_page);
  let startpage = totalPages === 4 ? 1 : current_page === 1 || current_page - 2 === 0 ? 1 : current_page === totalPages ? current_page - 2 : current_page - 1;
  let endPage = totalPages === 4 ? 4 : current_page === 1 ? current_page + 2 : current_page + 1 <= totalPages ? current_page + 1 : current_page;
  for (let i = startpage; i <= endPage; i++) {
    i <= totalPages && pages.push(i);
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [current_page]);

  const baseBtn = "flex items-center justify-center h-9 min-w-9 px-3 leading-tight rounded-full text-xs font-medium transition-all duration-150";
  const inactive = "bg-white border border-neutral-200 text-neutral-600 hover:border-primary/40 hover:text-primary hover:shadow-soft";
  const active = "bg-gradient-to-br from-primary to-accent text-white shadow-soft";
  const disabled = "bg-neutral-100 text-neutral-400 cursor-not-allowed pointer-events-none";

  return (
    <div className="pagination-box">
      <nav className="ms-auto me-auto custom-pagination" aria-label="Pagination">
        {total >= 1 ? (
          <ul className="inline-flex gap-1">
            <li>
              <a
                className={`${baseBtn} ${current_page === 1 ? disabled : inactive} cursor-pointer`}
                onClick={() => {
                  if (current_page === 1) return;
                  setParams((prev) => ({ ...prev, page: prev.page - 1 }));
                  window.scrollTo({ top: 0, behavior: "smooth" })
                }}
                aria-label="Previous page"
              >
                <RiArrowLeftSLine className="text-xl" />
              </a>
            </li>
            {totalPages - 2 <= current_page && totalPages > 4 && (
              <>
                <li>
                  <a className={`${baseBtn} ${inactive} cursor-pointer`} onClick={() => {
                    setParams((prev) => ({ ...prev, page: 1 }));
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }}>
                    1
                  </a>
                </li>
                <li>
                  <a className={`${baseBtn} bg-transparent text-neutral-400 cursor-default pointer-events-none`}>...</a>
                </li>
              </>
            )}
            {pages.map((i) => (
              <li key={i}>
                <a
                  className={`${baseBtn} cursor-pointer ${current_page === i ? active : inactive}`}
                  onClick={() => {
                    setParams((prev) => ({ ...prev, page: i }));
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }}
                >
                  {i}
                </a>
              </li>
            ))}
            {current_page + 1 < totalPages && totalPages > 4 && (
              <>
                {current_page + 2 < totalPages && (
                  <li>
                    <a className={`${baseBtn} bg-transparent text-neutral-400 cursor-default pointer-events-none`}>...</a>
                  </li>
                )}
                <li>
                  <a className={`${baseBtn} ${inactive} cursor-pointer`} onClick={() => {
                    setParams((prev) => ({ ...prev, page: totalPages }));
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }}>
                    {totalPages}
                  </a>
                </li>
              </>
            )}

            <li>
              <a
                className={`${baseBtn} ${current_page === totalPages ? disabled : inactive} cursor-pointer`}
                onClick={() => {
                  if (current_page === totalPages) return;
                  setParams((prev) => ({ ...prev, page: current_page + 1 }));
                  window.scrollTo({ top: 0, behavior: "smooth" })
                }}
                aria-label="Next page"
              >
                <RiArrowRightSLine className="text-xl" />
              </a>
            </li>
          </ul>
        )
          : null
        }
      </nav>
    </div>
  );
};

export default Pagination;
